

<template>

<div class="container-fluid px-0">
  <div class="row mx-0">
    <div class="col-12">
      <div class="py-1 ">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header pb-0">
                <div class="align-items-center">
                  <p class="mb-0 text-lg text-center text-black">
                    {{ currentMessages.InvoiceTitle }} 
                  </p>
                </div>
              </div>
              <div class="card-body">
              
                <div class="row">
                  <div class="col-md-12">
                    <label for="receiptsCode" class="form-control-label">
                        {{ currentMessages.ReceiptNoTitle }}</label>
                    <InputText v-model="receiptsCode" type="text" 
                    :placeholder="currentMessages.ReceiptNoTitlePlaceHolder" 
                      :class="{ 'is-invalid': receiptError }"
                    />
                      <small  v-if="receiptError" class="text-danger">{{ receiptError }}</small>
                  </div>
                  <div class="col-md-12">
                    <label for="storeNumber"  class="form-control-label">{{ currentMessages.StoreNoTitle }}</label>
                    <InputText v-model="storeNumber" type="text"
                    :placeholder="currentMessages.StoreNoTitlePlaceHolder" 
                    :class="{ 'is-invalid': storeError }"
                    
                    />
                      <small   v-if="storeError" class="text-danger">{{ storeError }}</small>
                  </div>
                
                </div>
              
                <hr class="horizontal dark" />
                  <div class="row">
                    <div class="col-md-6">
                        <GlobalButtonPrv @click="handleClickClear">
                        {{ currentMessages.ButtonClear }} <i class="fa fa-trash" aria-hidden="true"  style="font-size: 18px; margin-left:5px;"></i>

                        </GlobalButtonPrv>
                    </div>
                    <div class="col-md-6">
                      <GlobalButtonNext @click="handleClickNextPage"  :disabled="isSending" >
                        {{ currentMessages.ButtonSend }} <i class="fa fa-paper-plane" aria-hidden="true" style="font-size: 18px; margin-left:5px;"></i>
                      </GlobalButtonNext>
                  </div>
                </div>
              </div>
            </div>
          </div>
    
        </div>
        <div class="row mt-2">
            <div class="col-md-12">
              <img :src="receiptExamplePage" class="img-full-width"/>
          </div>
        </div>
      </div>

      <!-- <div class="row mt-3">
        <div class="col-md-3">
          <button class="btn btn-warning w-100" @click="showModalCase(1)">Test Case 1</button>
        </div>
      </div> -->

      </div>
  </div>
</div>
    
  <PopupModal
    :visible="isModalVisible"
    :title="modalTitle"
    :message="modalMessage"
    :subMessage="modalSubMessage"
    :closeText="closeText"
    @close="isModalVisible = false"
  />
</template>

<script setup>
import { computed,ref ,watch} from 'vue';
import receiptExamplePage from '@/assets/img/icons/pages/receipt_ex.png';
import GlobalButtonNext from "@/components/global/GlobalButtonPrimary.vue";
import GlobalButtonPrv from "@/components/global/GlobalButtonGrey.vue";
import PopupModal from "@/components/global/ModalAlert.vue"; 

import InputText from "@/components/global/InputText.vue";
import { useReceiptStoreEtax } from '@/store/useReceiptStoreEtax';
///
import { fetchGetOrderReceipt} from '/src/service-api/request-api-etax';
//language // 
import messages from '@/locales/messages';
import { useLanguageStore } from '@/store/useLanguageStore';
const languageStore = useLanguageStore();
const currentMessages = computed(() => messages[languageStore.selectedLanguage]);
//End language // 
const emit = defineEmits(['next', 'prev', 'sendotp', 'invoice', 'preview', 'submission']);

const receiptStore = useReceiptStoreEtax();

const receiptsCode = computed({
  get: () => receiptStore.receiptsCode,
  set: (val) => (receiptStore.receiptsCode = val),
});

const storeNumber = computed({
  get: () => receiptStore.storeNumber,
  set: (val) => (receiptStore.storeNumber = val),
});
const handleClickClear = () => {
  receiptsCode.value = '';
  storeNumber.value = '';
  receiptError.value = '';
  storeError.value = '';
};


const receiptError = ref('');
const storeError = ref('');
const isSending = ref(false);

const handleClickNextPage = async () => {
  if (isSending.value) return; // ป้องกันกดซ้ำ

  isSending.value = true; // ปิดปุ่มก่อน
  receiptError.value = '';
  storeError.value = '';

  const receipt = receiptsCode.value?.trim();
  const store = storeNumber.value?.trim();

  let hasError = false;
  if (!receipt) {
    receiptError.value = currentMessages.value.ValidationRequiredReceiptNo;
    hasError = true;
  }
  if (!store) {
    storeError.value = currentMessages.value.ValidationRequiredStoreNo;
    hasError = true;
  }
  if (hasError) {
    isSending.value = false; // เปิดปุ่มคืนถ้ามี error
    return;
  }

  try {
    const response = await fetchGetOrderReceipt({
      receipt_code: receipt,
      store_code: store,
    });

    if (response.fail_case) {
      if (response.fail_case === 7) {
        receiptStore.$patch({
          receiptsCode: receipt,
          storeNumber: store,
        });
        emit('next');
      } else {
        showModalCase(response.fail_case);
      }
      return;
    }

    receiptStore.$patch({
      receiptsCode: receipt,
      storeNumber: store,
    });
    emit('next');

  } catch (error) {
    modalTitle.value = "Error";
    modalMessage.value = currentMessages.value.FaildModalReasonCase10;
    isModalVisible.value = true;

  } finally {
    isSending.value = false; 
  }
};


// const handleClickNextPageBK = async () => {
//   receiptError.value = '';
//   storeError.value = '';

//   const receipt = receiptsCode.value?.trim();
//   const store = storeNumber.value?.trim();

//   let hasError = false;

//   if (!receipt) {
//     receiptError.value = currentMessages.value.ValidationRequiredReceiptNo;
//     hasError = true;
//   }

//   if (!store) {
//     storeError.value = currentMessages.value.ValidationRequiredStoreNo;
//     hasError = true;
//   }
//   if (hasError) return;

//   try {
//     const response = await fetchGetOrderReceipt({
//       receipt_code: receipt,
//       store_code: store,
//     });

//     // if (response.fail_case) {
//     //   showModalCase(response.fail_case);
//     //   return;
//     // }

//     if (response.fail_case) {

//       if (response.fail_case === 7) {
//         receiptStore.$patch({
//           receiptsCode: receipt,
//           storeNumber: store,
//         });
//         emit('next');
//         return;
//       }

//       showModalCase(response.fail_case);
//       return;
//     }


//     receiptStore.$patch({
//       receiptsCode: receipt,
//       storeNumber: store,
//     });

//     emit('next');

//   } catch (error) {
//     modalTitle.value = "Error";
//     modalMessage.value = error.message || "disconnected";
//     isModalVisible.value = true;
//   }
// };




const isModalVisible = ref(false);
const modalMessage = ref('');
const modalSubMessage = ref('');
const modalTitle = ref('');

const modalCases = computed(() => ({
  1: {
    message: currentMessages.value.FaildModalReasonCase1,
  },
  2: {
    message: currentMessages.value.FaildModalReasonCase2,
  },
  3: {
    message: currentMessages.value.FaildModalReasonCase3,
  },
  4: {
    message: currentMessages.value.FaildModalReasonCase4,
    subMessage: currentMessages.value.FaildModalReasonCase4_2,
  },
  5: {
    message: currentMessages.value.FaildModalReasonCase5,
  },
  6: {
    message: currentMessages.value.FaildModalReasonCase6,
  },
  7: {
    message: currentMessages.value.FaildModalReasonCase7,
  },
   10: {
    message: currentMessages.value.FaildModalReasonCase10,
  },
}));
const showModalCase = (caseNumber) => {
  const caseData = modalCases.value[caseNumber];

  modalTitle.value = currentMessages.value.FaildModalTitleCase1;

  modalMessage.value = caseData.message
    .replace('{inv}', receiptsCode.value)
    .replace('{store}', storeNumber.value);

  modalSubMessage.value = caseData.subMessage || '';
  isModalVisible.value = true;
};





watch(receiptsCode, (newVal) => {
  if (receiptError.value && newVal?.trim()) {
    receiptError.value = '';
  }
});

watch(storeNumber, (newVal) => {
  if (storeError.value && newVal?.trim()) {
    storeError.value = '';
  }
});

watch(
  () => languageStore.selectedLanguage,
  () => {
    if (receiptError.value) {
      receiptError.value = currentMessages.value.ValidationRequiredReceiptNo;
    }

    if (storeError.value) {
      storeError.value = currentMessages.value.ValidationRequiredStoreNo;
    }
  }
);
const closeText = computed(() => {
  return currentMessages.value?.ButtonClose || ""
})

//language
</script>

<style scoped>

.img-full-width {
  width: 100%;
  max-width: 100%;
  height: auto;
  display: block;
  padding: 10px;
  box-sizing: border-box;
}


.pd-10 {
  padding: 10px;
}

.mr-2{
  margin-right: 2px;

} 
.ml-2{
margin-left: 2px;
}

.mr-4{
  margin-right: 4px;

} 
.ml-4{
margin-left: 4px;
}

.mr-12{
  margin-right: 12px;

} 
.ml-12{
margin-left: 12px;
}

html, body {
  overflow-x: hidden !important;
}
html, body, #app {
  padding: 0 !important;
  margin: 0 !important;
}





</style>
